
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"75","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.353 10.5H55.59l-.024 3.5h-3.947V0c.002.019 3.248 0 4.853 0 4.15 0 6.618 1.46 6.618 5.25 0 3.451-1.973 5.25-5.736 5.25zm-.882-7.875c-.207 0-.647-.014-.882 0v5.25h.882c2.102 0 2.713-.788 2.713-2.542 0-1.697-.72-2.708-2.713-2.708zM21.177 14V8.312h-3.971V14h-3.97V0h3.97v5.688h3.97V0h3.972v14h-3.971zm7.058 0V0h3.971v14h-3.97zm14.528 0h-7.47V0h3.972v11.375h3.97L42.764 14zm1.796 0V0h3.97v14h-3.97zM68.383 3.5v.438C68.383 6.087 75 5.1 75 9.625 75 13.019 72.64 14 69.265 14c-1.328 0-3.47-.245-4.853-.438V10.5c1.218.621 3.525.875 4.853.875 1.494 0 1.765-.464 1.765-1.313 0-2.41-6.618-1.374-6.618-6.124C64.412 1.18 67.132 0 70.395 0c2.313 0 2.672.212 3.723.438v2.624c-.941-.395-2.256-.437-3.53-.437-1.16 0-2.205.14-2.205.875zm-62.648 7H3.97L3.947 14H0V0c.002.019 3.248 0 4.853 0 4.15 0 6.618 1.46 6.618 5.25 0 3.451-1.973 5.25-5.736 5.25zm-.882-7.875c-.207 0-.647-.014-.883 0v5.25h.883c2.102 0 2.713-.788 2.713-2.542 0-1.697-.721-2.708-2.713-2.708z","fill":"#0064D2"}})])
          )
        }
      }
    